import { apiFetch } from "./client";

interface AttachmentUploadResult {
  id: string;
  name: string;
  type: string;
  size: number;
}

/**
 * Uploads a File to Espo's Attachment entity via the standard
 * "Attachment from-string" flow. Returns the new attachment id which can be
 * passed to backend endpoints as `fileId`.
 *
 * Field hint helps Espo associate the file with the parent record type.
 */
export async function uploadAttachment(
  file: File,
  parentType: string,
  field: string,
): Promise<AttachmentUploadResult> {
  const fileBase64 = await fileToBase64(file);
  const body = {
    name: file.name,
    type: file.type || "application/octet-stream",
    role: "Attachment",
    relatedType: parentType,
    field,
    file: `data:${file.type || "application/octet-stream"};base64,${fileBase64}`,
  };
  return apiFetch<AttachmentUploadResult>("/Attachment", {
    method: "POST",
    body,
  });
}

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      const comma = result.indexOf(",");
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.onerror = () => reject(reader.error ?? new Error("file read failed"));
    reader.readAsDataURL(file);
  });
}
